import { BaseElement3d, BaseElement3dOptions } from "./BaseElement3d.js";

export interface Grid3dOptions extends BaseElement3dOptions {
    radius: number;
}

export class Grid3d extends BaseElement3d {

    private _radius: number;

    constructor(options: Grid3dOptions) {

        super();

        options = e5.object.merge({
            opacity: 0.05
        } as Grid3dOptions, options);

        this.create(options);

        this._radius = options.radius;

        const material = new THREE.LineBasicMaterial({ color: 0xFFFFFF, transparent: true, opacity: 1 });
        this.addMaterial(material);
        // this.opacity = 15 / 255;

        // this.opacity = 1;
        // gs.TweenMax.to(this, 4, {opacity: 0});

        var radius = this._radius;
        const geometries: THREE.BufferGeometry[] = [];
        var step = 64;
        var stepV = 18;
        var stepH = 36;
        var half = stepV / 2;
        for (var j = 0; j < stepV - 1; ++j) {
            var m = ((j + 1) - half) / half;
            var points: THREE.Vector3[] = [];
            var height = Math.sin(-m * Math.PI * 0.5) * radius;

            var c = height / radius;
            var Aa = Math.PI * 0.5 - Math.asin(c);
            var rad = Math.sin(Aa) * radius;

            for (var i = 0; i < step; ++i) {
                var r = (i / (step - 1));
                var x = Math.cos(r * Math.PI * 2) * rad;
                var y = Math.sin(r * Math.PI * 2) * rad;
                points.push(new THREE.Vector3(x, height, y));
            }
            const geometry = new THREE.BufferGeometry().setFromPoints(points);
            geometries.push(geometry);
        }

        var matrix = new THREE.Matrix4();
        for (var j = 0; j < stepH; ++j) {
            var points: THREE.Vector3[] = [];
            var rad = radius;
            var angle = (j / (stepH)) * Math.PI * 2;
            matrix.makeRotationY(angle);
            for (var i = 0; i < step; ++i) {
                var r = (i / (step - 1));

                var off = 10 * (Math.PI / 180);

                var ang = r * (Math.PI - 2 * off);
                ang += off;
                var x = Math.cos(ang) * rad;
                var y = Math.sin(ang) * rad;
                var p = new THREE.Vector3(0, x, y);
                p.applyMatrix4(matrix);
                points.push(p);
            }
            const geometry = new THREE.BufferGeometry().setFromPoints(points);
            geometries.push(geometry);
        }

        // var mergedGeometry = THREE.BufferGeometryUtils.mergeBufferGeometries(geometries);
        // const material = new THREE.LineBasicMaterial({ color: 0xFF00FF });
        // const line = new THREE.Line(mergedGeometry, material);
        // this._canvas.scene.add(line);


        for (var geo of geometries) {
            const line = new THREE.Line(geo, material);
            this.element.add(line);
        }
    }
}